import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('[Supabase] Missing environment variables: VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
}

// Custom lock implementation to prevent AbortError from Web Locks API
// in React Strict Mode where components double-mount/unmount
const customLock = async (name, acquireTimeout, fn) => {
  return await fn();
};

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    lock: customLock,
  },
  global: {
    fetch: (...args) => {
      return fetch(...args)?.catch((err) => {
        // Silently suppress network-level fetch failures (e.g. offline, DNS errors)
        // Return a fake 503 Response so Supabase internals handle it gracefully
        // without re-throwing an unhandled rejection to the console
        console.warn('[Supabase] Network unavailable:', err?.message);
        return new Response(JSON.stringify({ error: 'Network unavailable', message: err?.message }), {
          status: 503,
          headers: { 'Content-Type': 'application/json' },
        });
      });
    },
  },
});
